import { render, staticRenderFns } from "./TransactionHeader.vue?vue&type=template&id=593f04c3&scoped=true&lang=html&"
import script from "./TransactionHeader.vue?vue&type=script&lang=js&"
export * from "./TransactionHeader.vue?vue&type=script&lang=js&"
import style0 from "./TransactionHeader.vue?vue&type=style&index=0&id=593f04c3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "593f04c3",
  null
  
)

export default component.exports